import {Component, OnDestroy} from '@angular/core';
import {RouteReuseStrategy} from '@angular/router';
import {MarketplaceRouteReuseStrategy} from '../marketplace-route-reuse-strategy';

@Component({
    selector: 'app-marketplace',
    templateUrl: './marketplace.component.html',
    styleUrls: ['./marketplace.component.css'],
    standalone: false
})
export class MarketplaceComponent implements OnDestroy {

    constructor(private routeReuseStrategy: RouteReuseStrategy) {
    }

    ngOnDestroy(): void {
        if (this.routeReuseStrategy instanceof MarketplaceRouteReuseStrategy) {
            this.routeReuseStrategy.clear();
        }
    }

}
